import { Breadcrumb } from 'antd';
import classNames from 'classnames';
import type { HTMLAttributes } from 'react';
import type { ItemType } from 'antd/es/breadcrumb/Breadcrumb';

export type PageHeaderProps = HTMLAttributes<HTMLDivElement> & {
	showBreadcrumb?: boolean;
	breadcrumbItems?: ItemType[];
};

export const PageHeader = ({
	children,
	showBreadcrumb = false,
	breadcrumbItems = [{ title: 'Dashboard' }],
	...props
}: PageHeaderProps) => {
	const classes = classNames('page-header', props.className);
	return (
		<div {...props} className={classes}>
			{showBreadcrumb ? <Breadcrumb className="breadcrumb" items={breadcrumbItems} /> : null}
			{children}
		</div>
	);
};

export default PageHeader;
